<div *ngIf="authService.isSuperUser()" class="floating-switch">
  <mat-slide-toggle (toggleChange)="switchMode()" [checked]="!appService.editMode$" color="primary"></mat-slide-toggle>
  <span class="label"><b>עריכה</b></span>
</div>
